module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add text-pic1.f902d134.jpg";